<template>
  <div class="map-right-layers-add-files map-right-layers-add-files__container">
    <DragAndDropFile
      ref="dragAndDropRef"
      multiple
      :limit-size="20971520"
      :allowed-extensions="allowedExtensionsRef"
      :pre-add-file="preAddFile"
      @add-file="onAddFile"
    >
      <template #item>
        <div></div>
      </template>
    </DragAndDropFile>
    <div class="map-right-layers-add-files__group-files">
      <Item
        v-for="(file, key) of props___.files"
        :key="file.name + key + Math.random()"
        :item="file"
        @change-coordinate="(coordinate) => onChangeCoordinate(file, coordinate)"
        @click-remove="() => removeFile(file)"
      />
    </div>
  </div>
</template>


<script setup>
// vue
import {ref, inject} from 'vue';

// sttedra
import {DragAndDropFile} from '@sttedra_ui/framework';

// components
import Item from './MapRight.Layers.AddFiles.Item';

// composables
import readFile from '@/composables/readFile/readFile';

// #region Props, Emits
const props___ = defineProps({
  files: {
    type: Array,
    default: () => [],
  },
});
const emits = defineEmits(['new-file', 'update-files']);
// #endregion


// #region Params, Ref, Reactives, Computed
const allowedExtensionsRef = ref('.geojson,.json,.kml,.gml');
const modelMapRef = inject('modelMapRef');
const dragAndDropRef = ref();
// const filesRef = ref([]);
// #endregion


// #region Functions
function onAddFile(file) {
  emits('new-file', file);
}

/**
 * Function callback when add the file
 *
 * @param {File} file
 *
 * @retun {File}
 */
async function preAddFile(file) {
  const extension = file.name.split('.').pop();
  file.coordinateSystem = null;
  if (extension.toLowerCase() === 'geojson' || extension.toLowerCase() === 'json') {
    const {result} = await readFile(file);
    const json = JSON.parse(result);
    if (json?.crs?.properties?.name) {
      file.coordinateSystem = modelMapRef.value.coordinatesSystem.find((coordinate) => {
        return json?.crs?.properties?.name.includes(coordinate.srid);
      });
    }
  }
  return file;
}

/**
 * Event when the coordinate has been changed
 *
 * @param {Object} item
 * @param {Object} coordinateSystem
 *
 */
function onChangeCoordinate(item, coordinateSystem) {
  const newFiles = props___.files.map((itemFound) => {
    if (itemFound === item) {
      item.coordinateSystem = coordinateSystem;
      return item;
    }
    return itemFound;
  });
  emits('update-files', newFiles);
}

/**
 * Remove the file of the array
 *
 * @param {Object} file
 */
function removeFile(file) {
  const newFiles = props___.files.filter((item) => {
    if (file !== item) {
      return item;
    }
  });
  emits('update-files', newFiles);
}

// #endregion


// #region Effects, Hooks
// ...
// #endregion


// #region Provide, Expose
// ...
// #endregion
</script>


<style lang="scss" scoped>
.map-right-layers-add-files {
  &__item {
    padding: 10px;
    display: flex;
    align-items: center;

    &__label {
      flex: 1 1 100%;
    }

    &__buttons {
      flex: 0 0 auto;

      &__button {
        cursor: pointer;

        &--red {
          color: $brand__color--red;
        }
      }
    }
  }

  &__group-files {
    max-height: 300px;
    overflow: auto;
  }


}
</style>
